import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { FormContext, FormErrorTypes } from 'dash-ui';

import { FormFields } from './AccountInfo.constants';
import { DashValidation, isEmptyOrNil, isNameLengthValid } from 'dash-common';

const useValidation = () => {
  const { errorHandlers } = useContext(FormContext);
  const { t } = useTranslation(['forms', 'common', 'pages']);

  const validateFieldByName = (fieldName: FormFields, value: string) => {
    const setInvalid = (message: string,  values?: Record<string, string>) => {
      errorHandlers[fieldName]({
        type: FormErrorTypes.Invalid,
        message: t(message, values || {}),
      });
    };

    // check specific fields type
    switch (fieldName) {
      case FormFields.FirstName:
      case FormFields.LastName:
        if (isEmptyOrNil(value)) {
          setInvalid(
            fieldName === FormFields.FirstName
              ? 'forms:messages.firstNameBlank'
              : 'forms:messages.lastNameBlank'
          );
          return false;
        }
        if (!isNameLengthValid(value)) {
          setInvalid('forms:messages.maxCharacterLimit', {
            number: DashValidation.MaxNameLength.toString(),
          });
          return false;
        }
        break;
    }
    errorHandlers[fieldName](null);
    return true;
  };

  return validateFieldByName;
};

export default useValidation;
